import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const vendorAdsApiService = createApi({
  reducerPath: 'vendorAdsApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/purchased-ads/'),
  endpoints: (builder) => ({
    // Get all vendor ads (for browsing)
    getAllVendorAds: builder.query({
      query: (args) => ({
        url: 'admin/all',
        method: 'GET',
        params: args
      }),
      keepUnusedDataFor: 0
    }),
  })
})

export const {
  useGetAllVendorAdsQuery
} = vendorAdsApiService
